import { useCallback } from "react"
import { API_ENDPOINTS } from "../../../api/endpoints"
import { useApi } from "../../../hooks/useApi"

export const useDeleteUserAuth0 = () => {
  const api = useApi()

  return useCallback(
    (userId: string): Promise<unknown> =>
      api.del(`${API_ENDPOINTS.BASE}auth0/users/${userId}`, {
        errorMessage: "Error al eliminar el usuario en Auth0",
      }),
    [api],
  )
}
